import { UndefinedSchema, UnknownSchema } from '../../constants'
import { SchemaDefinition } from '../../models/SchemaDefinition'

import type { SchemaUndefinedSpecific } from '../../types'

export class SchemaUndefinedDefinition extends SchemaDefinition {
  override defaultsMerge(value: any) {
    return value
  }

  override getIn(schema: SchemaUndefinedSpecific, path: PropertyKey[]) {
    if (path.length === 0) return schema
    return UnknownSchema
  }

  override infer(target?: any, schema?: SchemaUndefinedSpecific) {
    return schema ?? UndefinedSchema
  }

  override inferOnlySchema(schema: SchemaUndefinedSpecific) {
    return schema
  }

  override inferTypeScript(): string {
    return `undefined`
  }

  override prune(target: any): any {
    return target
  }

  override transform() {
    return
  }

  override validate(target: any, schema: SchemaUndefinedSpecific): void {
    this.validateMetadata(target, schema, 'undefined')
  }
}
